export default {
    SET_CREDENTIALS: (state, payload) => {
        state.credentials = payload.credentials;
    },
    SET_ACCOUNT_DETAILS: (state, payload) => {
        state.accountDetails = payload.accountDetails;
    },
};